var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEthereumMobileLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666992 17.8861C0.666992 8.22118 8.50198 0.386078 18.167 0.386078C27.832 0.386078 35.667 8.22118 35.667 17.8861C35.667 27.5511 27.832 35.3861 18.167 35.3861C8.50198 35.3861 0.666992 27.5511 0.666992 17.8861ZM21.5945 17.2416C20.5142 17.3018 19.6354 17.2104 18.7567 17.1189C17.8779 17.0274 16.9992 16.936 15.9187 16.9962C15.4003 17.0251 14.8504 17.0981 14.3281 17.2205C14.6466 13.3607 17.4751 9.98372 21.3215 9.76944C23.6818 9.63784 26.0407 11.0455 26.169 13.3303C26.2948 15.5761 24.5217 17.0784 21.5945 17.2416ZM15.8087 25.3781C13.5726 25.4988 11.3378 24.2084 11.2164 22.1139C11.097 20.0554 12.7769 18.6783 15.5498 18.5287C16.5734 18.4735 17.406 18.5573 18.2384 18.6412C19.071 18.725 19.9036 18.8088 20.9271 18.7536C21.4184 18.7272 21.9392 18.6601 22.4341 18.5479C22.1324 22.0861 19.4526 25.1816 15.8087 25.3781Z",
    fill: "#ECEEF3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereumMobileLight);
export default __webpack_public_path__ + "static/media/ethereum_mobile_light.47145817.svg";
export { ForwardRef as ReactComponent };